module.exports = __webpack_public_path__ + "img/wh_04.6bf6e9c5.png";